import { render, staticRenderFns } from "./SensitiveAreaKeyword.vue?vue&type=template&id=883d00a0&"
import script from "./SensitiveAreaKeyword.vue?vue&type=script&lang=js&"
export * from "./SensitiveAreaKeyword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports